import { Link, Outlet, useLocation } from 'react-router-dom';
import { BrandMark } from '@/shared/components/BrandMark';
import { AppFooter } from '@/shared/components/AppFooter';
import { cn } from '@/lib/utils';

/** Branded auth layout for login and register flows. */
export function AuthLayout() {
  const { pathname } = useLocation();
  const isLogin = pathname === '/login';

  return (
    <div className="auth-shell relative flex min-h-screen flex-col overflow-hidden">
      <div className="auth-shell__glow auth-shell__glow--a" aria-hidden />
      <div className="auth-shell__glow auth-shell__glow--b" aria-hidden />
      <div className="auth-shell__grid" aria-hidden />

      <div
        className={cn(
          'relative z-10 flex flex-1 flex-col items-center justify-center px-4 py-8 sm:px-6',
          isLogin ? 'lg:py-10' : 'py-10'
        )}
      >
        {!isLogin ? (
          <div className="mb-8 animate-auth-fade-up text-center">
            <Link to="/login" className="inline-flex justify-center">
              <BrandMark full />
            </Link>
          </div>
        ) : null}

        <div className={cn('w-full', isLogin ? 'max-w-5xl' : 'max-w-md')}>
          <Outlet />
        </div>
      </div>

      <div className="relative z-10">
        <AppFooter />
      </div>
    </div>
  );
}
